module.exports = __webpack_public_path__ + "media/crush.8d1d84ae.webm";